export default "/fonts/vendor/fontsource-roboto/files/roboto-cyrillic-ext-400-italic.woff2?c30985e07ee67f55f3e88654eced96ad";